/**
 * Professional Portal Routes
 */
import React, { Suspense } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useProfessionalAuth } from '../context/ProfessionalAuthContext';

const ProfessionalLoginPage = React.lazy(() => import('../pages/professional/LoginPage'));
const ProfessionalRegisterPage = React.lazy(() => import('../pages/professional/RegisterPage'));
const ProfessionalDashboardPage = React.lazy(() => import('../pages/professional/DashboardPage'));
const ReviewDetailPage = React.lazy(() => import('../pages/professional/ReviewDetailPage'));

function PageLoader() {
  return (
    <div className="min-h-screen bg-[#F7F5EE] flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-[#567D38] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function ProtectedProfessionalRoute() {
  const { isAuthenticated, isLoading } = useProfessionalAuth();
  if (isLoading) return <PageLoader />;
  if (!isAuthenticated) return <Navigate to="/professional/login" replace />;
  return <Outlet />;
}

function PublicProfessionalRoute() {
  const { isAuthenticated, isLoading } = useProfessionalAuth();
  if (isLoading) return <PageLoader />;
  if (isAuthenticated) return <Navigate to="/professional/dashboard" replace />;
  return <Outlet />;
}

export function ProfessionalRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<PublicProfessionalRoute />}>
          <Route path="login" element={<ProfessionalLoginPage />} />
          <Route path="register" element={<ProfessionalRegisterPage />} />
        </Route>
        <Route element={<ProtectedProfessionalRoute />}>
          <Route path="dashboard" element={<ProfessionalDashboardPage />} />
          <Route path="reviews/:id" element={<ReviewDetailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/professional/login" replace />} />
      </Routes>
    </Suspense>
  );
}

export default ProfessionalRoutes;
